import React, { useState } from "react";
// import { useToast } from "@chakra-ui/react";
import NodeContext from "./NotesContext";
const host = process.env.REACT_APP_BASE_URL;

const NodeState = (props) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progVar, setProgVar] = useState(false);
  // localStorage.setItem("token", null);
  // variables for the edit the notes
  const [note, setNote] = useState({ title: "", description: "", tag: "" }); // IT SET THE NOTES FOR ADDING AND EDITING THE NOTES
  const [idToBeDeleted, setIdToBeDeleted] = useState(""); // SET THE ID FOR EDITING PURPOSE
  const [show, setShow] = useState(false); // IT SHOWS THE MODAL FOR WHEN STATE IS CHANGED

  // variable for the edit the notes end

  // variable for the setting the alerts

  const [alert, setAlert] = useState(false);
  const [alertVariant, setAlertVariant] = useState("success");
  const [alertMessage, setAlertMessage] = useState("this is just a alert");
  const setAlertsMessageFunc = (message, alertVar) => {
    setAlertVariant(alertVar);
    setAlert(true);
    setAlertMessage(message);
  };
  //

  const notesInitial = [];
  const [notes, setNotes] = useState(notesInitial);

  //  variables for setting the login email and password

  const [credential, setCredential] = useState({ email: "", password: "" });

  // login functionality

  const login = async ({ email, password }) => {
    setProgVar(true);
    setProgress(0);
    const response = await fetch(`${host}/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    setProgress(50);
    const data = await response.json();
    setProgress(80);
    return data;
  };

  // sign up functionality

  const [newUserCredentails, setNewUserCredentails] = useState({
    name: "",
    email: "",
    password: "",
    username: "",
  });

  const signUp = async ({ name, email, password, username }) => {
    setProgVar(true);
    setProgress(0);
    let uname = name;
    const response = await fetch(`${host}/api/auth/createuser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: uname, email, password, username }),
    });
    setProgress(50);
    const data = await response.json();
    setProgress(80);
    return data;
  };

  // fetch all notes

  const getAllNotes = async () => {
    setLoading(true);
    const response = await fetch(`${host}/api/notes/getallnotes`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
    });
    const json = await response.json();
    setLoading(false);
    setNotes(json.notes);
  };

  // add a note
  const addnote = async ({ title, description, tag }) => {
    setLoading(true);
    const response = await fetch(`${host}/api/notes/addnote`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify({ title, description, tag }),
    });

    let note = await response.json().then((result) => {
      return result;
    });
    setAlertsMessageFunc("Note Added", "success");
    setNotes(notes.concat(note));
    setLoading(false);
  };

  // delete a note
  const deletenote = async (id) => {
    setLoading(true);
    const response = await fetch(`${host}/api/notes/deletenote/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
    });

    const newNotes = notes.filter((note) => {
      return note._id !== id;
    });

    setAlertsMessageFunc("Note Deleted", "warning");
    setNotes(newNotes);
    setLoading(false);
  };
  // edit a note

  const editnote = async (id, title, description, tag) => {
    // api call
    setLoading(true);
    const response = await fetch(`${host}/api/notes//updatenote/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify({ title, description, tag }),
    });
    const json = response.json();
    // console.log(json);
    // for client side editing
    for (let i = 0; i < notes.length; i++) {
      if (notes[i]._id === id) {
        notes[i].title = title;
        notes[i].description = description;
        notes[i].tag = tag;
      }
    }
    setAlertsMessageFunc("Note Edited", "success");
    getAllNotes();
    setLoading(false);
  };
  return (
    <NodeContext.Provider
      value={{
        notes,
        addnote,
        deletenote,
        editnote,
        getAllNotes,
        show,
        setShow,
        setIdToBeDeleted,
        idToBeDeleted,
        note,
        setNote,
        alert,
        setAlert,
        alertMessage,
        alertVariant,
        setAlertsMessageFunc,
        credential,
        setCredential,
        login,
        newUserCredentails,
        setNewUserCredentails,
        signUp,
        setLoading,
        loading,
        progress,
        setProgress,
        progVar,
        setProgVar,
      }}
    >
      {props.children}
    </NodeContext.Provider>
  );
};

export default NodeState;
